import { boolean, number, string, struct, union } from 'io-ts/lib/Decoder';

/**
 * UI → BE: user's choice for a single frame
 */
export const LengthCorrectionChoice = union(
	struct({
		frameId: string,
		chosenLength: number,
	}),
	struct({
		frameId: string,
		isUnsure: boolean,
	})
);
